import React, { Fragment } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper
} from "@material-ui/core";

export default class ComponentToPrint extends React.Component {
  splitInstallments = (installmentCount, total, numberOfInstallmentCols) => {
    const rows = Math.ceil(installmentCount / numberOfInstallmentCols);
    const installmentValue = installmentCount > 0 ? total / installmentCount : 0;

    return Array.from({ length: rows }).map((_, rowIndex) => {
      const startCol = rowIndex * numberOfInstallmentCols;
      const endCol = Math.min((rowIndex + 1) * numberOfInstallmentCols, installmentCount);
      return {
        installments: Array.from({ length: numberOfInstallmentCols }).map((_, colIndex) => {
          const actualCol = startCol + colIndex;
          return actualCol < endCol ? installmentValue : null;
        }),
        startOrdinal: startCol + 1
      };
    });
  };
  render() {
    const { factoryItemList, searchData, groupFactoryItems, itemRequestDetail, getMaxInstallmentCountFromAllRecords, getOrdinalName } = this.props;
    return (
      <div>
        <style>
          {`
            .MuiTableCell-root {
              padding: 2px !important;
            }
            .MuiTableRow-root {
              height: 20px !important;
              min-height: 20px !important;
            }
            @page {
              size: A4 portrait;
            }
              @media print {
              .table-container {
                max-width: 100%;
                overflow-x: hidden
              }
            }
          `}
        </style>

        <h3><center><u>Factory Item Details Report</u></center></h3>
        <br />
        <div className="row pl-2 pb-4 pt-4">
          <div className="col"><center><b>Group:</b> {searchData.groupName}</center></div>
          <div className="col"><center><b>Factory:</b> {searchData.factoryName}</center></div>
          <div className="col"><center><b>Date:</b> {searchData.startDate} - {searchData.endDate}</center></div>
          <div className="col"><center><b>Route:</b> {searchData.routeName == undefined ? 'All Route' : searchData.routeName}</center></div>
        </div>
        <br />

        <Box style={{ minWidth: 1050, padding: 3 }}>
          {factoryItemList.length > 0 &&
            groupFactoryItems(factoryItemList).map((routeGroup) => (
              <Fragment key={routeGroup.routeName}>
                <Typography variant="h5" style={{ fontWeight: "bold", color: "#333", marginBottom: 10 }}>
                  Route: {routeGroup.routeName}
                </Typography>

                {routeGroup.categories.map((categoryGroup) => {
                  const totalQuantity = categoryGroup.items.reduce((sum, item) => sum + item.approvedQuantity, 0);
                  const totalPrice = categoryGroup.items.reduce((sum, item) => sum + item.totalPrice, 0);
                  const maxCols = getMaxInstallmentCountFromAllRecords(factoryItemList);
                  const numberOfInstallmentCols = maxCols >= 6 ? 6 : maxCols;

                  return (
                    <Fragment key={categoryGroup.categoryName}>
                      <Typography variant="h6" style={{ marginBottom: 10 }}>
                        Category: {categoryGroup.categoryName}
                      </Typography>
                      <TableContainer component={Paper} style={{ marginBottom: 20 }} className="table-container">
                        <Table style={{ tableLayout: "fixed", width: "100%" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Created Date</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Issuing Date</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Effective Month</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Reg No.</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Supplier Name</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Item</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Quantity</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>No of Installments</TableCell>
                              <TableCell colSpan={numberOfInstallmentCols} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Installments</TableCell>
                              <TableCell rowSpan={2} style={{ textAlign: "right", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Total Price (Rs)</TableCell>
                            </TableRow>
                            <TableRow>
                              {Array.from({ length: numberOfInstallmentCols }).map((_, index) => (
                                <TableCell key={index} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>
                                  {getOrdinalName(index + 1)}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {categoryGroup.items.map((item, index) => {
                              const installmentCount = Number(item.noOfInstallments) || 0;
                              const total = Number(item.totalPrice) || 0;
                              const installmentRows = this.splitInstallments(installmentCount, total, numberOfInstallmentCols);
                              return installmentRows.map((row, rowIndex) => (
                                <Fragment key={`${index}-${rowIndex}`}>
                                  {rowIndex > 0 && (
                                    <TableRow>
                                      <TableCell colSpan={7}></TableCell>
                                      {Array.from({ length: numberOfInstallmentCols }).map((_, colIndex) => (
                                        <TableCell key={colIndex} style={{ textAlign: "center", fontWeight: 'bold', borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>
                                          {getOrdinalName(row.startOrdinal + colIndex)}
                                        </TableCell>
                                      ))}
                                      <TableCell></TableCell>
                                    </TableRow>
                                  )}
                                  <TableRow>
                                    {rowIndex === 0 ? (
                                      <>
                                        <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.date.split("T")[0]}</TableCell>
                                        <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.issuingDate.split("T")[0]}</TableCell>
                                        <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.paymentEffectedMonth+'-'+ item.paymentEffectedYear || '-'}</TableCell>
                                        <TableCell style={{ textAlign: "left", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.registrationNumber}</TableCell>
                                        <TableCell style={{ textAlign: "left", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.name}</TableCell>
                                        <TableCell style={{ textAlign: "left", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.itemName}</TableCell>
                                        <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.approvedQuantity}</TableCell>
                                        <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{item.noOfInstallments}</TableCell>
                                      </>
                                    ) : (
                                      <TableCell colSpan={numberOfInstallmentCols + 1} style={{ borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}></TableCell>
                                    )}
                                    {row.installments.map((value, colIndex) => (
                                      <TableCell key={colIndex} style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>
                                        {value !== null
                                          ? value.toLocaleString("en-US", { minimumFractionDigits: 2 })
                                          : '-'
                                        }
                                      </TableCell>
                                    ))}
                                    {rowIndex === 0 ? (
                                      <TableCell style={{ textAlign: "right", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>
                                        {Number(item.totalPrice).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                      </TableCell>
                                    ) : (
                                      <TableCell></TableCell>
                                    )}
                                  </TableRow>
                                </Fragment>
                              ));
                            })}
                            <TableRow>
                              <TableCell style={{ fontWeight: "bold", textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>Total</TableCell>
                              <TableCell colSpan={5}></TableCell>
                              <TableCell style={{ fontWeight: "bold", textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{totalQuantity}</TableCell>
                              <TableCell colSpan={numberOfInstallmentCols + 1}></TableCell>
                              <TableCell style={{ fontWeight: "bold", textAlign: "right", borderRight: "1px solid rgba(224, 224, 224, 1)", borderLeft: "1px solid rgba(224, 224, 224, 1)" }}>{totalPrice.toFixed(2)}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fragment>
                  );
                })}
              </Fragment>
            ))}
        </Box>
      </div>
    );
  }
}